import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { NetworkStatus } from '@apollo/client';
import { Card, Grid, Typography, ListItemText } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { ErrorComponent, LoadingSpinner } from '../../../../components';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';
import { userLanguage } from '../../../../core/AuthContext';

import PieceModelsList from '../PieceModelsList';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import PieceUpdateDialog from '../PieceUpdateDialog';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
}

const PieceDetails: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [isUpdatePieceDialogOpen, setIsUpdatePieceDialogOpen] = useState(false);

  const pieceId = PlatformNavigation.pieceDetails.paramsFromPath(useRouteMatch()).pieceId;

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.piece.getPiece({
    pieceId: pieceId
  });

  const reloadData = () => {
    refetch().then();
  };

  if (loading || networkStatus === NetworkStatus.refetch) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={reloadData}
        message={error.message}
      />
    );

  return (
    <Grid container direction="row">
      <Grid item md={6} style={{ marginBottom: '8px' }}>
        <Card style={{ padding: '8px' }}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ marginRight: '2px' }} variant={'h6'}>
              Piece Details
            </Typography>
            <EditIcon
              fontSize="small"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsUpdatePieceDialogOpen(true)}
            />
          </div>
          <PublishableStatusComponent
            text="Piece publishable"
            status={GQLOperationBuilder.piece.pieceAssetFromResponse(data).isPublishable}
          />
          <ListItemText
            primary="Piece name"
            secondary={GQLOperationBuilder.piece.pieceAssetFromResponse(data).piece.title[userLanguage]}
          />
          <ListItemText
            primary="Geometry"
            secondary={GQLOperationBuilder.piece.pieceAssetFromResponse(data).piece.geometryType}
          />
        </Card>
      </Grid>

      <PieceModelsList
        party={party}
        pieceId={pieceId}
        models={GQLOperationBuilder.piece.pieceAssetFromResponse(data).piece.models}
      />

      {isUpdatePieceDialogOpen && (
        <PieceUpdateDialog
          piece={GQLOperationBuilder.piece.pieceAssetFromResponse(data)}
          party={party}
          onClose={success => {
            if (success === true) {
              successNotification(toast, 'Piece updated successfully', () => {});
            }

            setIsUpdatePieceDialogOpen(false);
          }}
        />
      )}
    </Grid>
  );
};

export default PieceDetails;
